import { PUBLIC_PAGE_API_ENDPOINT } from "../constants"

export const getAntiforgeryToken = async () => {
	return await fetch(PUBLIC_PAGE_API_ENDPOINT + "/api/antiforgery", {
		credentials: "include",
	})
		.then((res) => {
			return res.json().then((antiforgeryToken) => {
				return antiforgeryToken.message
			})
		})
		.catch((e) => {
			console.error(e)
		})
}
